/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NotAdmin.vue?vue&type=template&id=14341e06&"
import script from "./NotAdmin.vue?vue&type=script&lang=js&"
export * from "./NotAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NotAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports